import axios from "axios";
import NProgress from "nprogress";


const apiClient = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});


const url = "https://www.wohnungsdatenbank.uni-freiburg.de/backend/Settings/";

export default {
  updateSettings(v, c) {

    return apiClient.get(url + "updateSettings.php", {
        params: {
            value: v,
            category: c
          }
    });
  },
  updateSettingsName(id, name){
      return apiClient.get(url + "editSettings.php", {
          params: {
              id: id,
              name: name
          }
      });
  },
  removeSettings(id){
    return apiClient.get(url + "removeSettings.php", {
        params: {
            id: id
          }
    });
  },
  getSettings(c) {
    return apiClient.get(url +"getSettings.php", {
        params:{
            category: c
        }
    });
  },

};
